var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthWrapper',[_c('AuthLayout',[_c('div',{staticClass:"aside"},[_c('div',{staticClass:"feedback-wrapper"},[_c('CustomerFeedback')],1)]),_c('div',{staticClass:"main"},[_c('AuthFormWrapper',[_c('PageTitle',{attrs:{"big":""}},[_vm._v(" "+_vm._s(_vm.$t('registration.title'))+" ")]),_c('RegistrationForm')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }